export default __webpack_public_path__ + "static/media/cross_wht.dc37aab7.svg";